module.exports = __webpack_public_path__ + "static/assets/5e460dab4dfda0fe34f93d3faf95b778.svg";